module.exports = __webpack_public_path__ + "media/images/avatar/development/parents/4-9f8b44a1a4ceacaff8c423a8128dcee3.jpg";